// extracted by mini-css-extract-plugin
export var wrapper = "Layout-module--wrapper--13P0z";
export var sitetop = "Layout-module--sitetop--1ESxY";
export var navbar = "Layout-module--navbar--2j9Pm";
export var heading = "Layout-module--heading--3W4ia";
export var footer = "Layout-module--footer--3r6XS";
export var text = "Layout-module--text--2jyU1";
export var links = "Layout-module--links--Zb1rm";
export var detail = "Layout-module--detail--MsZ_o";